import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../AppIcon';
import { useCompanyCapabilities } from '../../hooks/useCompanyCapabilities';
import type { CapabilityKey } from '../../api/Navigation/moduleConfig';

/** Page-level explanation of why a surface is read-only, sibling to `RestrictedWriteNotice`. */

/** Id of the reason text, for any read-only control that needs to reference it. Mount one notice per page. */
export const MANAGED_ELSEWHERE_REASON_ID = 'managed-elsewhere-reason';

interface Props {
  capability: CapabilityKey;
  className?: string;
}

const ManagedElsewhereNotice: React.FC<Props> = ({ capability, className }) => {
  const { t } = useTranslation();
  const { can, loaded } = useCompanyCapabilities();

  if (!loaded || can(capability)) return null;

  return (
    <div
      role="status"
      data-testid="managed-elsewhere-notice"
      className={`flex items-start gap-3 rounded-lg border border-border bg-muted p-4 ${className ?? ''}`}
    >
      <Icon name="Info" size={18} className="mt-0.5 shrink-0 text-muted-foreground" />
      <div className="min-w-0 space-y-1">
        <p className="text-sm font-medium text-foreground">{t('managedElsewhere.notice.heading')}</p>
        <p id={MANAGED_ELSEWHERE_REASON_ID} className="text-sm text-muted-foreground">
          {t('managedElsewhere.notice.body')}
        </p>
      </div>
    </div>
  );
};

export default ManagedElsewhereNotice;
